if (!( (window).__divanoPdpShare)) {
   (window).__divanoPdpShare = true;

  const nav =  (window.navigator);
  const canNative = typeof nav.share === 'function';
  const canCopy = Boolean(nav.clipboard && typeof nav.clipboard.writeText === 'function');

  if (canNative || canCopy) {
    document.documentElement.classList.add('divano-can-share');

    let busy = false;
    const clearTimers = new WeakMap();

    const shareUrl = () => {
      const url = new URL(window.location.origin + window.location.pathname);
      const variant = new URLSearchParams(window.location.search).get('variant');
      if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
      return url.toString();
    };

    const publish = (method, productId) => {
      try {
         (window).Shopify?.analytics?.publish?.('divano_pdp_share', { method, product_id: productId });
      } catch (error) {
      }
    };

    const statusFor = (button) => {
      const own = button.isConnected ? button.parentElement?.querySelector('[data-divano-share-status]') : null;
      if (own instanceof HTMLElement) return own;
      const any = [...document.querySelectorAll('[data-divano-share-status]')].find((el) => !el.closest('quick-add-dialog'));
      return any instanceof HTMLElement ? any : null;
    };

    let pendingWrite = 0;

    const clearMessage = (button) => {
      window.clearTimeout(pendingWrite);
      const status = statusFor(button);
      if (status) {
        window.clearTimeout(clearTimers.get(status));
        status.textContent = '';
      }
    };

    const announce = (button, text) => {
      clearMessage(button);
      pendingWrite = window.setTimeout(() => {
        const status = statusFor(button);
        if (!status) return;
        window.clearTimeout(clearTimers.get(status));
        status.textContent = text;
        clearTimers.set(
          status,
          window.setTimeout(() => {
            status.textContent = '';
          }, 3000)
        );
      }, 60);
    };

    document.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target && target.closest('[data-divano-share]');
      if (!(button instanceof HTMLButtonElement)) return;
      if (button.closest('quick-add-dialog')) return;
      if (busy) return;
      const shot = {
        url: shareUrl(),
        title: button.dataset.divanoShareTitle || document.title,
        productId: Number(button.dataset.divanoShareProduct) || null,
        copied: button.dataset.divanoShareCopied || 'Link copied',
        failed: button.dataset.divanoShareFailed || "Couldn't copy the link",
      };
      busy = true;
      clearMessage(button);
      try {
        if (canNative) {
          try {
            await nav.share({ title: shot.title, url: shot.url });
            publish('native', shot.productId);
            return;
          } catch (error) {
            if (error &&  (error).name === 'AbortError') return;
            if (!canCopy) {
              announce(button, shot.failed);
              return;
            }
          }
        }
        try {
          await nav.clipboard.writeText(shot.url);
        } catch (error) {
          announce(button, shot.failed);
          return;
        }
        announce(button, shot.copied);
        publish('copy', shot.productId);
      } finally {
        busy = false;
      }
    });
  }
}
